import React, { useEffect, useState, useContext } from "react";
import "../CSS/MainLogin.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logIn, logOut } from "../Redux/Action/index";
import Axios from "axios";
import { logInStatus } from "../Redux/Action/loginstatus";
import LoadingSpinner from "../Components/Loading";
import Select from "react-select";
import LoginImg from "../Images/logoPOS.png";
import Footer from "../Components/Footer";
import { AuthContext } from "../context/AuthContext";
import { setSelectedModule } from "../Redux/Action/selModule";

const MainLogin = () => {
  const { setAuthUser } = useContext(AuthContext);

  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(false);
  const [userCode, setUserCode] = useState("");
  const [userCodeError, setUserCodeError] = useState("");
  const [errData, setErrData] = useState("");
  const [servererror, setserverError] = useState("");
  let serverResponse = true;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modeOfLogin, setModeOfLogin] = useState("");
  const [modeOfLoginValue, setModeOfLoginValue] = useState("");

  // Remembered device-login info (for fingerprint/PIN login)
  // const [rememberedUser, setRememberedUser] = useState(
  //   JSON.parse(localStorage.getItem("rememberedLogin") || "null")
  // );

  function clearState() {
    dispatch(logIn([]));
    dispatch(logInStatus("FALSE"));
  }
  useEffect(() => {
    clearState();
  }, []);

  function isValidUserCode(code) {
    return /^\d{5}$/.test(code);
  }

  function handleUserCodeChange(e) {
    const value = e.target.value;
    // only allow digits, cap at 5 characters
    // if (/^\d{0,5}$/.test(value)) {
      setUserCode(value);
      setUserCodeError("");
    // }
  }

  function routeToDashboard(mode) {
    // if (mode === "POS ORDER TAKER") navigate("/ORDERTAKERDASHBOARD");
    if (mode === "POS ORDER TAKER") navigate("/MyListofOrders");
    else if (mode === "POS") navigate("/HomePage");
    else if (mode === "KITCHEN") navigate("/KitchenDashboard");
    else if (mode === "DASHBOARD LOGIN") navigate("/ListofOrdersReady");
    else if (mode === "POS CASHIER") navigate("/PosCashierUnpaidBills");
  }

  function handleClick() {
    // if (!isValidUserCode(rememberedUser ? rememberedUser?.userCode : userCode)) {
    //   setUserCodeError("Enter a valid 5-digit user code");
    //   return;
    // }

    // if (rememberedUser) {
    //   if (!rememberedUser?.userCode) {
    //      setUserCodeError("Enter a valid user code");
    //   return;
    //   }
    // } else {
      if (!userCode) {
         setUserCodeError("Enter a valid user code");
      return;
      }
    // }
    setIsLoading(true);
    if (serverResponse) {
      Axios.post(`${BASEURL}/login`, {
        // USERCODE: rememberedUser ? rememberedUser?.userCode : userCode,
        USERCODE: userCode,
      })
        .then((response) => {
          try {
            if (response.data.message) {
              setIsLoading(false);
              setserverError(response.data.message);
              dispatch(logIn([]));
              dispatch(logInStatus("FALSE"));
            } else {
              dispatch(logIn(response.data));
              dispatch(logInStatus("TRUE"));
              window.sessionStorage.setItem("auth-token", response.data.authToken);
              window.sessionStorage.setItem("session-token", response.data.sclientSecret);
              setAuthUser(response.data.authToken);
              dispatch(setSelectedModule(response?.data?.user?.userName))

              // Offer to remember this device for fingerprint/PIN login next time
              // if (!rememberedUser) {
              //   if (window.confirm("Remember this login with your fingerprint/PIN?")) {
              //     enableDeviceLogin();
              //   }
              // }

              routeToDashboard(response?.data?.user?.userName);
              setIsLoading(false);
            }
          } catch {
            if (response.status === 501) {
              setserverError("Internal server error");
            } else if (response.status === 401) {
              setserverError("Invalid user code");
            }
            setIsLoading(false);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              setserverError("Invalid user code");
            } else if (error.response.status === 501) {
              setserverError("Internal server error");
            }
            setIsLoading(false);
          } else {
            setserverError("No response from server or invalid user code");
            setIsLoading(false);
          }
        });
    } else {
      setserverError("Server is down. Please try again later.");
      setIsLoading(false);
    }
  }

  // ---------- Fingerprint / device PIN login ----------

  // function bufferEncode(value) {
  //   return btoa(String.fromCharCode(...new Uint8Array(value)))
  //     .replace(/\+/g, "-")
  //     .replace(/\//g, "_")
  //     .replace(/=+$/, "");
  // }

  // function bufferDecode(value) {
  //   return Uint8Array.from(
  //     atob(value.replace(/-/g, "+").replace(/_/g, "/")),
  //     (c) => c.charCodeAt(0)
  //   );
  // }

  // async function enableDeviceLogin() {
  //   if (!window.PublicKeyCredential) return; // not supported on this browser/device
  //   try {
  //     const cred = await navigator.credentials.create({
  //       publicKey: {
  //         challenge: crypto.getRandomValues(new Uint8Array(32)),
  //         rp: { name: "MarsTrack POS" },
  //         user: {
  //           id: crypto.getRandomValues(new Uint8Array(16)),
  //           name: userCode,
  //           displayName: `User ${userCode}`,
  //         },
  //         pubKeyCredParams: [{ type: "public-key", alg: -7 }],
  //         authenticatorSelection: {
  //           authenticatorAttachment: "platform", // built-in fingerprint/Windows Hello only
  //           userVerification: "required",
  //         },
  //         timeout: 60000,
  //       },
  //     });

  //     const remembered = {
  //       userCode,
  //       credentialId: bufferEncode(cred.rawId),
  //     };
  //     localStorage.setItem("rememberedLogin", JSON.stringify(remembered));
  //     setRememberedUser(remembered);
  //   } catch (err) {
  //     console.log("Could not enable device login:", err);
  //   }
  // }

  // async function loginWithDevice() {
  //   if (!rememberedUser) return;
  //   handleClick()
  // }

  // function forgetDevice() {
  //   localStorage.removeItem("rememberedLogin");
  //   setRememberedUser(null);
  // }

  const renderList = (
    <div>
      <div className="for__amin__login__size">
        <div className="header">
          <picture className="pic__name">
            <p className="company__name__top text-[25px]">MarsTrack POS</p>
            <img
              className="image__style"
              src={LoginImg}
              alt=""
              width="500"
              height="300"
            />
            <h1 className="company__name__bottom">Marstrack POS</h1>
          </picture>

          <div className="form">
            <main className="mainpage">
              <p
                style={
                  servererror === "Server is connected"
                    ? { color: "green", display: "flex", justifyContent: "center", alignItems: "center" }
                    : { color: "red", display: "flex", justifyContent: "center", alignItems: "center" }
                }
              >
                {servererror}
              </p>
              <h2 className="headeruselogin text-[20px]">Login Page</h2>

              <div className="form_group">
                <p className="loginerror">
                  <span className="skew-shake-x">{errData}</span>
                </p>

                <label htmlFor="userCode" style={{ marginTop: "12px", display: "block" }}>
                  User Code
                </label>
                <input
                  type="password"
                  inputMode="numeric"
                  // pattern="\d{5}"
                  // maxLength={5}
                  className={`form_control input ${userCodeError ? "invalid-email" : ""}`}
                  id="userCode"
                  name="userCode-nofill" // non-standard name so browsers don't associate it with saved "userCode" entries
                  autoComplete="off" 
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  placeholder="Enter user code"
                  value={userCode}
                  onChange={handleUserCodeChange}
                />
                {userCodeError && (
                  <small style={{ color: "red" }}>{userCodeError}</small>
                )}
              </div>

              <div className="loginpagebtn">
                <button
                  disabled={serverResponse === true ? false : true}
                  onClick={handleClick}
                  type="submit"
                  className="submitbutton1"
                >
                  Login
                </button>
              </div>

              {/* {rememberedUser && (
                <div className="loginpagebtn" style={{ marginTop: "10px" }}>
                  <button
                    type="button"
                    className="submitbutton1"
                    onClick={loginWithDevice}
                  >
                    🔒 Login with Fingerprint / PIN
                  </button>
                  <div style={{ textAlign: "center", marginTop: "6px" }}>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        forgetDevice();
                      }}
                      style={{ fontSize: "12px" }}
                    >
                      Not you? Forget this device
                    </a>
                  </div>
                </div>
              )} */}
            </main>
          </div>
        </div>
      </div>
      <div className="footer__login__page">
        <Footer />
      </div>
    </div>
  );

  return <div>{isLoading ? <LoadingSpinner /> : renderList}</div>;
};

export default MainLogin;